import { VdpTitle } from '../components/vdp/title.vue';
Vue.component('vdp-title', VdpTitle);